import { FeatureTile, PasswordRule } from '../models';
import { ImageFilterType } from 'capacitor-plugin-scanbot-sdk';

export type OAuthGrants = 'password' | 'code';
export type ContentHeaderSizes = 'md' | 'lg';

export interface Authentication {
  grants: Array<OAuthGrants>;
}

export interface ScanbotConfiguration {
  documentScannerConfig: {
    primaryColor: string;
    secondaryColor: string;
  };
  filter?: ImageFilterType;
  shouldBinarize?: boolean;
  showAcknowledgeScreen?: boolean;
}

export interface IonicConfiguration {
  dashboard: {
    menuTiles?: Array<FeatureTile>;
    contentHeader?: {
      size?: ContentHeaderSizes;
    };
  };
  footer?: {
    hasCustomBorder?: boolean;
    hasCustomBackground?: boolean;
  };
  scanbot: ScanbotConfiguration;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  [index: string]: unknown;
}

export interface HealthConfiguration {
  timeout: number;
}

export interface Customization {
  allowPdfUpload?: boolean;
  allowUserSelfDelete?: boolean;
  enableInAppRating?: boolean;
  hasBescheide: boolean;
  hasUebersicht: boolean;
  hasUnfinishedAntrage: boolean;
  health?: HealthConfiguration;
  ionic?: IonicConfiguration;
  preventUnlockingWithLogin?: boolean;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  [index: string]: unknown;
}

export interface Environment {
  authentication: Authentication;
  customizing: Customization;
  onlyWeb?: boolean;
  passwordRules?: PasswordRule;
  showDataPrivacyPage?: boolean;
  request?: {
    /**
     * Gibt an ob Baden-Württemberg spezifische Statusse dargestellt werden.
     */
    hasCustomRequestStates?: boolean /**
     * Gibt an ob Baden-Württemberg spezifische Antragstypen dargestellt werden.
     */;
    hasCustomRequestType?: boolean;
  };
  sentry?: {
    dsn: string;
    tracesSampleRate?: number;
    tracePropagationTargets?: Array<string | RegExp>;
    replaysSessionSampleRate?: number;
    replaysOnErrorSampleRate?: number;
  };
  // eslint-disable-next-line @typescript-eslint/member-ordering
  [index: string]: unknown;
  pinConfiguration: PinConfiguration;
}

export type PinConfiguration = {
  storage: 'persistent' | 'session';
};
export const DefaultPinConfiguration: PinConfiguration = {
  storage: 'persistent',
};
